module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_8_74cf82c51ee89fd9cb339f93f0866769.png";